import { BpmnModel, BpmnModelHelper, ExtensionMethod, MexExpression, ServiceTask } from "@edp-pmf/bpmn-model";
import { MergeActivity } from "@edp-bpm/bpmn-common-model";

export class MergeBillActivity extends MergeActivity {
    static Clr_Type_ID: string = "bpm.MergeBillActivity";
    ClrTypeID: string = MergeBillActivity.Clr_Type_ID;

    constructor(model: BpmnModel) {
        super(model);
    }

    ResetBeforeLoadFrom() {
        super.ResetBeforeLoadFrom();
    }

    ConvertToJsonObject(): any {
        let obj = super.ConvertToJsonObject();
        return obj;
    }

    LoadFromJsonObject(obj: any) {
        super.LoadFromJsonObject(obj);
    }

    NewInstance(): MergeBillActivity {
        return new MergeBillActivity(this.Model);
    }

    clone(): MergeBillActivity {
        const c = super.clone() as MergeBillActivity;
        c.Name = this.Name;
        c.NameLanguage = this.NameLanguage && {
            ...this.NameLanguage,
        };

        return c;
    }
}
BpmnModelHelper.RegisterElementType(new MergeBillActivity(new BpmnModel()));